module.exports = __webpack_public_path__ + "static/media/plusround.27ca738f.svg";